<app-spinner></app-spinner>
<div class="content">
	<div  *ngIf="shown.grid" class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="padding: 10px;">
	<mat-card style="margin-bottom:10px;padding: 5px;"> <mat-form-field appearance="outline" 
			style="width:30%"> <mat-label>Search Category</mat-label> <input matInput type="text" 
			(keyup)="categoryFilter($event.target.value)"> </mat-form-field>
		<div style="float: right; padding: 10px; cursor: pointer;" mat-raised-button  matTooltip="Add" matTooltipPosition="left"
			color="blue " class=" " (click)="CategoryForm()" mat-flat-button>
			<img src="assets/img/icons/group-31.png ">
		</div>
		</mat-card>
			
<mat-card>
	<table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">

		<!--- Note that these columns can be defined in any order.
	The actual rendered columns are set as a property on the row definition" -->


		<ng-container matColumnDef="Id">
			<th mat-header-cell *matHeaderCellDef>Id</th>
			<td mat-cell *matCellDef="let element">{{element.categoryId}}</td>
		</ng-container>

		<ng-container matColumnDef="Sno">
			<th mat-header-cell *matHeaderCellDef>S.No</th>
			<td mat-cell *matCellDef="let element ">{{dataSource.filteredData.indexOf(element)+1}}</td>
		</ng-container>

		<!-- Position Column -->
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let element">{{element.name}}</td>
		</ng-container>

		<ng-container matColumnDef="Description">
			<th mat-header-cell *matHeaderCellDef>Description</th>
			<td mat-cell *matCellDef="let element">{{element.description}}</td>
		</ng-container>

		<!-- <ng-container matColumnDef="Edit">
			  <th mat-header-cell *matHeaderCellDef>Edit</th>
			  <td mat-cell *matCellDef="let element" (click)="editCategory(element.categoryId)">
				  <mat-icon appearance="outline" style="width:2%;color: green;cursor:pointer;font-size: 20px;">edit</mat-icon>
			  </td>
	</ng-container> -->



		<ng-container matColumnDef="Edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let element" class="pointer"  >
				<img matTooltip="Edit" matTooltipPosition="left" (click)="editCategory(element.categoryId)" src="assets/img/icons/forma-1-copy-2.png ">
			</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell class="pointer"   *matCellDef="let element;let i = index"  >
				<img matTooltip="Delete" matTooltipPosition="left" (click)="deleteCategory(element.categoryId,i)"  src="assets/img/icons/forma-1.png ">
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
	</table>
		<mat-paginator [pageSizeOptions]="[10, 20,100]" showFirstLastButtons 
                [pageIndex]="pageIndex" 
                [pageSize]="pageSize" (page)="pageEvent = handlePage($event)"></mat-paginator>
		</mat-card>
	</div>
<!-- Form Begin -->
<div *ngIf="shown.Form">
	<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
		<div class="Categorybox">
			<form [formGroup]="Category" class="example-form">
			<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
				<mat-form-field appearance="outline" class="example-full-width" style="width:100%">
					<input (keypress)="handleInput($event)" matInput placeholder="Category" formControlName="name" value="">
        </mat-form-field>
        <mat-error *ngIf="validator.UniqueCategory">{{validator.errorMessage}}</mat-error>
      </div>

        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
          <mat-form-field appearance="outline" style="width:100%">
            <textarea  matInput placeholder="Description" formControlName="description"></textarea>
          </mat-form-field>
        </div>

				<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
				<button [disabled]="!Category.valid"  mat-flat-button class="btn" (click)="createCategory()">Submit</button>
				<button mat-flat-button class="btn" (click)="backcategoryList()">Cancel</button>
        </div>
			</form>
		</div>
</div>
</div>
</div>
